// @flow

import React from "react";
import { connect } from "react-redux";

import { SelectedUser as StyledUser } from "./styles";
import Icon from "src/icons";
import type { AppState, UID, UnifizeUser } from "src/types";
import { getUser } from "src/reducers";

type Props = {
  uid: UID,
  user: UnifizeUser,
  removeSelectedUser: Function,
};

const SelectedUser = ({ uid, user, removeSelectedUser }: Props) => {
  const { displayName } = user;
  return (
    <StyledUser>
      <span>{displayName}</span>
      <Icon type="detach" handleClick={() => removeSelectedUser(uid)} />
    </StyledUser>
  );
};

const mapStateToProps = (
  { app }: { app: AppState },
  { uid }: { uid: UID },
) => ({
  user: getUser(app, uid),
});

export default connect(mapStateToProps)(SelectedUser);
